import styled from 'styled-components';
import { normalize, withModifiers } from 'utils';
import { ReactComponent as Spinner } from 'styles/icons/spinner.svg';
import { color, typography } from 'styles/settings';

const borderWidth = '2px';

export const StyledButton = styled.button`
  /* background-color: ${color.brand.gold}; */
  background: ${({ theme }) => theme.primary};
  border: none;
  border-radius: 10px 0 10px 0;
  cursor: pointer;
  display: block;
  opacity: ${({ opacity = 1 }) => opacity};
  padding: ${normalize('10px')} ${normalize('16px')};

  * {
    color: ${color.neutral.black};
  }

  &:focus {
    outline: none;
  }

  &:active {
    outline: none;
  }

  ${withModifiers('secondary')`
    background-color: ${color.neutral.grayLight};
    * {
      color: ${color.neutral.gray};
    }
  `}

  ${withModifiers('tertiary')`
    background-color: ${color.neutral.plainBlack};

    * {
      color: ${color.neutral.white};
    }
  `};

  ${withModifiers('quaternary')`
    background-color: ${color.brand.blue};

    * {
      color: ${color.neutral.white};
    }
  `};

  ${withModifiers('disabled')`
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  `};

  ${withModifiers('loading')`
    opacity: 0.4;
  `};

  ${withModifiers('alt')`
    
  `};

  ${withModifiers('link')`
    background-color: transparent;
    border-radius: 0;
    border: 0;
    padding: 0;
    * {
      color: ${color.brand.gold};
    }
  `};

  ${withModifiers('outlined')`
    background-color: transparent;
    border-color: ${color.neutral.white};
    border-width: ${borderWidth};
    border-style: solid;
  `};

  ${withModifiers('outlined', 'alt')`
    border-color: ${color.ui.accentSecondary};
  `};

  ${withModifiers('danger')`
    border-color: ${color.ui.danger};
    * {
      color: ${color.ui.danger};
    }
  `};
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);

  ${withModifiers('notLink')`
    flex: 1;
  `}

  ${withModifiers('link')`
    height: auto;
    padding: 0;
  `}
`;

export const Label = styled.span`
  ${typography.font.semiBold};
  font-size: ${typography.size.rg};
  line-height: ${typography.size.ml};
  position: relative;
  left: 3px;

  ${withModifiers('upperCase')`
    text-transform: uppercase;
  `};

  ${withModifiers('outlined')`
  `};

  ${withModifiers('outlined', 'alt')`
  `};

  ${withModifiers('link')`
    ${typography.font.semiBold};
  `}

  ${withModifiers('underline')`
    text-decoration-line: underline;
  `};
`;

export const Loader = styled(Spinner)`
  height: ${normalize(25)};
  width: 0;
  margin-left: ${normalize('8px')}!important;
  transition: all 0.3s linear;
  ${withModifiers('$loading')`
    width: ${normalize(25)};
  `};
`;
